import { ReportTableColumn } from '../../../shared/components/reports-table/reports-table.component';

export function tableColumns(): ReportTableColumn[] {
  return [
    {
      key: 'areaStatus',
      label: 'Situação',
      sortable: false,
      type: 'status',
    },
    {
      key: 'areaIdentification',
      label: 'Identificação da Área',
      sortable: true,
      sortKey: 'idArea',
    },
    {
      key: 'area',
      label: 'Área (ha)',
      sortable: true,
      sortKey: 'areaHa',
    },
    {
      key: 'cities',
      label: 'Municípios/UF',
      sortable: false,
      type: 'cities',
    },
    {
      key: 'cpfCnpj',
      label: 'CPF/CNPJ',
      sortable: true,
      sortKey: 'document',
    },
    {
      key: 'car',
      label: 'CAR',
      sortable: true,
      sortKey: 'car',
    },
    {
      key: 'producer',
      label: 'Produtor',
      sortable: true,
      sortKey: 'producer',
    },
    {
      key: 'contract',
      label: 'Contrato',
      sortable: true,
      sortKey: 'contract',
    },
    {
      key: 'insurancePolicy',
      label: 'Apólice',
      sortable: true,
      sortKey: 'insurancePolicy',
    },
    {
      key: 'farmName',
      label: 'Nome da Fazenda',
      sortable: true,
      sortKey: 'farmName',
    },
  ];
}
